import React, { ChangeEvent, useState, useEffect } from 'react'
import { NavDropdown } from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import swal from 'sweetalert';
import i18n from '../../translate/i18n';
import DataTable from 'react-data-table-component';

import './styles.css'

// ICONS
import { FiClipboard, FiEdit } from 'react-icons/fi'
import { FaSearch, FaCheckCircle, FaMinusCircle } from 'react-icons/fa';

const customStyles = {
  headRow: {
    style: {
      color: '#FFD35B',
      background: '#00537A',
    },
  },
  table: {
    style: {
      minHeight: '400px'
    }
  }
}

//SERVICES
import { getOsFromUser, updateOs } from '../../services/OsService';

export default function TableOs() {

  const [data, setData] = useState<any[]>([]);
  const [search, setSearch] = useState<string>('');
  const [role, setRole] = useState<string>('user');
  const [filteredData, setFilteredData] = useState<any[]>([]);


  useEffect(() => {
    getData();
  }, [])


  const getData = () => {
    getOsFromUser().then(async (res) => {
      const response = res?.data?.rows
      const newUser: any = localStorage.getItem('user');
      const newUserJson = JSON.parse(newUser);
      await setRole(newUserJson.role);

      setData(response);
      setFilteredData(response)
    })
      .catch(err => { })
  }

  // filtra de acordo com pesquisa
  const filterList = (event: ChangeEvent<HTMLFormElement>) => {
    const { value } = event.target;
    setSearch(value);

    const newList = data?.filter((item) => JSON.stringify(item).toLowerCase().indexOf(value.toLowerCase()) !== -1);

    setFilteredData(newList)

  }

  const openOS = (id: string) => {
    swal({
      title: 'Tem certeza que deseja REABRIR essa O.S. ?',
      buttons: [
        'Não',
        'Sim, reabrir!'
      ],
      dangerMode: true,
      icon: 'info',
      timer: 20000
    }).then(function (isConfirm) {
      if (isConfirm) {
        updateOs({ id, finalizado: false }).then(res => {
          getData()
        })
      }
    })


  }



  // formada dados para arquivo de extração
  const formatData = (data: any) => {
    return data.map((i: any) => {
      return {

        'SINDICANCIA': i.sindicancia || '',
        'SEGURADORA': i.seguradora || '',
        'TIPO SINDICANCIA': i.tipoSindicancia || '',
        'SINISTRO': i.sinistro || '',
        'VISTORIA': i.vistoria || '',
        'SEGURADO': i.segurado || '',
        'RELATO CROQUI': i.relatoCroqui || '',
        'NATUREZA': i.natureza || '',
        'VEICULO': i.veiculo || '',
        'PLACA': i.placa || '',
        'NOME PRESTADOR': i.prestador?.name || '',
        'BEMSEGURADO': i.bemSegurado || '',
        'INDENIZACAO': i.indenizacao || '',
        'ENDERECO': i.endereco || '',
        'PRIORIDADE': i.prioridade || '',
        'RESULTADO': i.resultado || '',
        'CAUSA': i.causa || '',
        'REGULARIDADE': i.regularidade || '',
        'CONCLUSAO': i.conclusao || '',
        'VALORPROGRESSO': i.valorProgresso || '',
        'DATA ABERTURA': i.createdAt || '',
        'DATA ULTIMA ALTERACAO': i.updatedAt || '',
        'DISTANCIA': i.distance || '',
        'DURAÇÃO TRAJETO': i.duration || '',
        'ENDEREÇO INICIAL': i.start_address || '',
        'ENDEREÇO FINAL': i.end_address || '',
        'VIA': i.via || '',
        'IML': i.iml || '',
        'MAO': i.mao || '',
        'SINALIZACAO': i.sinalizacao || '',
        'CANTEIRO': i.canteiro || '',
        'ILUMINACAO': i.iluminacao || '',
        'LOCAL': i.local || '',
        'RELATO ORGAOS': i.relatoOrgaos || '',
        'DPTO POLICIA': i.dptoPolicia || '',
        'OCORRENCIA': i.ocorrencia || '',
        'BOMBEIROS': i.bombeiros || '',
        'CONCESSIONARIA': i.concessionaria || '',
        'HOSPITAL': i.hospital || '',
        'REDES SOCIAIS': i.redesSociais?.relato || '',
        'PROFISSAO SEGURADO': i.profissaoSegurado || '',
        'LOCALP ERNOITE': i.localPernoite || '',
        'UNICO CONDUTOR': i.unicoCondutor || '',
        'RESID IDADE': i.residIdade || '',
        'RESID IDADE VEICULO': i.residIdadeVeiculo || '',
        'CONDUTOR PRINCIPAL': i.condutorPrincipal || '',
        'POSSUI CADASTRO APLICATIVO': i.possuiCadastroAplicativo || '',
        'CADASTRO APLICATIVO': i.cadastroAplicativo || '',
        'HAVIA PASSAGEIRO': i.haviaPassageiro || '',
        'ENDOSSO PARTICULAR COMERCIAL': i.endossoParticularComercial || '',
        'ENDOSSO ANTES DEPOIS': i.endossoAntesDepois || '',
        'EXTRATO CORRIDA': i.extratoCorrida || '',
        'MEDIA KM DIA SEMANA': i.mediaKmDiaSemana || '',
        'KMATUAL': i.kmAtual || '',
        'SEG CONVIVIO COMERCIAL': i.segConvivioComercial || '',
        'SEG CONVIVIO COMERCIAL RELATO': i.segConvivioComercialRel || '',
        'SEG CONVIVIO RESIDENCIAL': i.segConvivioResidencial || '',
        'SEG CONVIVIO RESIDENCIAL RELATO': i.segConvivioResidencialRel || '',
        'LISTARTERCEIROS': i.listarTerceiros || '',
        'TER CONVIVIO COMERCIAL': i.terConvivioComercial || '',
        'TER CONVIVIO COMERCIAL RELATO': i.terConvivioComercialRel || '',
        'TER CONVIVIO RESIDENCIAL': i.terConvivioResidencial || '',
        'TER CONVIVIO RESIDENCIAL RELATO': i.terConvivioResidencialRel || '',
        'TRANSCRICAOENTREVISTA': i.transcricaoEntrevista || '',
        'NOTA': i.nota || '',
        'FINALIZADO': i.finalizado || '',
        'PAVIMENTACAO': i.pavimentacao || '',
        'TIPO TRECHO': i.tipoTrecho || '',
        'NIVEL': i.nivel || '',
        'ACOSTAMENTO': i.acostamento || '',
        'PERMISSAO ESTACIONAR': i.permissaoEstacionar || '',
        'TESTEMUNHAS': i.testemunhas || '',
        'MONITORAMENTO': i.monitoramento || '',
        'VIGILANCIA': i.vigilancia || '',
        'AREA': i.area || '',
        'SEG CONVIVIO COMERCIAL CPF': i.segConvivioComercialCPF || '',
        'NUMEROOCORRENCIA': i.numeroOcorrencia || '',
        'SEG CONVIVIO COMERCIAL NOME': i.segConvivioComercialNome || '',
        'SEG CONVIVIO COMERCIAL UF': i.segConvivioComercialUF || '',
        'SEG CONVIVIO COMERCIAL CIDADE': i.segConvivioComercialCidade || '',
        'SEG CONVIVIO RESIDENCIAL CPF': i.segConvivioResidencialCPF || '',
        'SEG CONVIVIO RESIDENCIAL NOME': i.segConvivioResidencialNome || '',
        'SEG CONVIVIO RESIDENCIAL UF': i.segConvivioResidencialUF || '',
        'SEG CONVIVIO RESIDENCIAL CIDADE': i.segConvivioResidencialCidade || '',
        'TER CONVIVIO COMERCIAL CPF': i.terConvivioComercialCPF || '',
        'TER CONVIVIO COMERCIAL NOME': i.terConvivioComercialNome || '',
        'TER CONVIVIO COMERCIAL UF': i.terConvivioComercialUF || '',
        'TER CONVIVIO COMERCIAL CIDADE': i.terConvivioComercialCidade || '',
        'TER CONVIVIO RESIDENCIAL CPF': i.terConvivioResidencialCPF || '',
        'TER CONVIVIO RESIDENCIAL NOME': i.terConvivioResidencialNome || '',
        'TER CONVIVIO RESIDENCIAL UF': i.terConvivioResidencialUF || '',
        'TER CONVIVIO RESIDENCIAL CIDADE': i.terConvivioResidencialCidade || '',
        'LOCAL SINISTRO': i.localSinistro || '',
        'FEEDBACK': i.feedback,
        'ANALISTA SINISTRO': i.analistaSinistro || '',
        'DATA AREA SINDICANCIA': i.dateAreaSindicancia || '',

      }
    })
  }


  return (

    <div className="container-box d-block position-relative mt-3 ">

      <div className="row">
        <div className="col-md-6 d-flex">
          <div className="filter-os">
            <FaSearch className="fa-search"></FaSearch>
            <input type="text" placeholder={i18n.t<string>('processes.search')} value={search}
              onChange={(event: any) => filterList(event)}
            />
          </div>
          <CSVLink
            filename={`export_sindicante_digital.csv`}
            data={formatData(filteredData)}
            separator={';'}
            className={'btn-primary-outline color-black ms-2 export-data'}
          >
            {i18n.t<string>('processes.export')}
          </CSVLink>
        </div>
      </div>
      <div className="col-md-12 pt-4 h-100">

        <DataTable

          noDataComponent="Sem informações para serem exibidas"
          striped
          customStyles={customStyles}
          pagination
          fixedHeader
          theme="solarized"
          paginationComponentOptions={{
            rowsPerPageText: 'Registros por página',
            rangeSeparatorText: 'de',
            selectAllRowsItem: true,
            selectAllRowsItemText: 'Todos',
          }}
          columns={[
            {
              name: 'Status',
              sortable: true,
              cell: (row?: any) =>
                <NavDropdown title={row.finalizado
                  ? <span className='os-finalizada'>{i18n.t<string>('processes.completed')}</span>
                  : i18n.t<string>('processes.in progress')
                } id="basic-nav-dropdown">
                  {row.finalizado
                    ? role === 'admin' ? <NavDropdown.Item onClick={() => { openOS(row.id) }}><FiEdit /> Reabrir</NavDropdown.Item> : ''
                    : (role != 'viewer' && <NavDropdown.Item href={`/editar/${row.id}`}><FiEdit /> {i18n.t<string>('processes.to edit')}</NavDropdown.Item>)
                  }
                  <NavDropdown.Item href={`/relato/${row.id}`}><FiClipboard /> {i18n.t<string>('processes.report')}</NavDropdown.Item>
                  {/*(role === 'admin' || role === 'manager') && <NavDropdown.Item onClick={() => { deleteOS(data.id) }}><strong>Deletar</strong></NavDropdown.Item>*/}
                </NavDropdown>
              ,
            },
            {
              name: i18n.t<string>('processes.sinister'),
              sortable: true,
              selector: (row?: any) => row?.sinistro || '',
            },
            {
              name: i18n.t<string>('processes.date'),
              sortable: true,
              selector: (row?: any) => row?.createdAt.split('T')[0] || '',
            },
            {
              name: i18n.t<string>('processes.provider'),
              sortable: true,
              selector: (row?: any) => row?.prestador && row?.prestador.name || '',
            },
            {
              name: i18n.t<string>('processes.well insured'),
              sortable: true,
              selector: (row?: any) => row?.bemSegurado || '',
            },
            {
              name: i18n.t<string>('processes.regularity'),
              sortable: true,
              selector: (row?: any) => row?.regularidade || '',
            },
            {
              name: '%',
              sortable: true,
              cell: (row?: any) =>
                <NavDropdown title={(row?.valorProgresso.toFixed(0) || 0) + '%'} id="basic-nav-dropdown">
                  <NavDropdown.Item>{row?.progresso.registro ? <FaCheckCircle color='var(--color-success)' /> : <FaMinusCircle color='var(--color-warning)' />} Registro</NavDropdown.Item>
                  <NavDropdown.Item>{row?.progresso.redesSociais ? <FaCheckCircle color='var(--color-success)' /> : <FaMinusCircle color='var(--color-warning)' />} Redes Sociais</NavDropdown.Item>
                  <NavDropdown.Item>{row?.progresso.entrevista ? <FaCheckCircle color='var(--color-success)' /> : <FaMinusCircle color='var(--color-warning)' />} Entrevistas</NavDropdown.Item>
                  <NavDropdown.Item>{row?.progresso.croqui ? <FaCheckCircle color='var(--color-success)' /> : <FaMinusCircle color='var(--color-warning)' />} Pesquisa local</NavDropdown.Item>
                  <NavDropdown.Item>{row?.progresso.orgaosPublicos ? <FaCheckCircle color='var(--color-success)' /> : <FaMinusCircle color='var(--color-warning)' />} Orgãos públicos</NavDropdown.Item>
                  <NavDropdown.Item>{row?.progresso.conclusao ? <FaCheckCircle color='var(--color-success)' /> : <FaMinusCircle color='var(--color-warning)' />} Conclusão</NavDropdown.Item>
                </NavDropdown>
            },
          ]
          }
          data={filteredData}
        />
      </div>
    </div >

  )
}
